<template>
  <div>
    <h2>{{ $t('upload.photos') }}</h2>

    <v-card class=" mb-10 pa-6" elevation="0" tile>
      <v-row v-if="alreadyHasPhotos">
        <v-col>
          <div class="d-flex align-center" v-if="onRemoveSelection">
            <v-checkbox v-model="selectedAllPhotos" @click="selectAllPhotos" class="mr-1"/>
            <span class="text-h6 font-weight-light">
              Selecionar todas
            </span>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="(photo, key) in selectedPhotos"
          :key="key"
          class="d-flex child-flex"
          cols="6" sm="4"
        >
        <v-checkbox v-model="photosToRemove" :value="key" v-if="onRemoveSelection" />

          <v-hover v-slot="{ hover }">
            <v-img
              @click="showPhoto(getUrl(key))"
            :src="getUrl(key)"
            contain
            height="120px"
            class="grey lighten-2 "
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular indeterminate color="primary" />
              </v-row>
            </template>

            <v-overlay v-if="!onRemoveSelection"
                :class="{ 'pointer': hover }"
                :value="hover"
                absolute
              >
                <v-icon color="primary" large>
                  mdi-eye
                </v-icon>
              </v-overlay>
          </v-img>
          </v-hover>
        </v-col>

        <v-col v-if="!alreadyHasPhotos">
          <h5 class="text-h5 text-center">
            {{ $t('realty.label.doesNotHavePhotos') }}
          </h5>
          <p class="text-h6 font-weight-light text-center">
            {{ $t('realty.label.addClickingBelow') }}
          </p>
        </v-col>
      </v-row>

      <v-divider v-if="alreadyHasPhotos" class="my-5" />

      <v-row>
        <v-col v-if="!onRemoveSelection" :class="{'justify-end': alreadyHasPhotos, 'justify-center': !alreadyHasPhotos}" class="d-flex">
          <v-btn
            @click="$refs.photoInputUpload.click()"
            icon
            color="primary"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <input
            v-show="false"
            multiple="multiple"
            ref="photoInputUpload"
            type="file"
            @change="updatePhotos"
          />
        </v-col>

        <v-col v-if="alreadyHasPhotos && !onRemoveSelection" class="d-flex justify-start">
          <v-btn
            icon
            color="error"
            @click="handleRemoveSelection"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>

        <v-col v-if="onRemoveSelection && alreadyHasPhotos" class="d-flex justify-end">
          <v-btn
            @click="handleRemoveSelection"
            text
            color="primary">
            <span>
              Cancelar
            </span>
          </v-btn>
        </v-col>
        <v-col v-if="onRemoveSelection && alreadyHasPhotos" class="d-flex justify-start">
          <v-btn @click="deletePhotos" :disabled="photosToRemove.length <= 0" text color="error">
            <span>
              Remover
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <ShowPhotoModal ref="photoModal" />
  </div>
</template>

<script>
import ShowPhotoModal from '@/components/realty/ShowPhotoModal'

export default {
  name: 'CreateRealtyPhotos',
  props: {
      value: {
          required: true
      }
  },
  components: {
    ShowPhotoModal
  },
  data() {
    return {
      selectedPhotos: [],
      photosToRemove: [],
      hover: false,
      onRemoveSelection: false,
      selectedAllPhotos: false
    }
  },
  computed: {
      alreadyHasPhotos() {
          return this.selectedPhotos.length >= 1
      }
  },
  watch: {
      selectedPhotos(newValue) {
          this.$emit('input', newValue)
      }
  },
  methods: {
    getUrl(photoIndex) {
      const photo = this.selectedPhotos[photoIndex]
      if (!photo) return
      return URL.createObjectURL(photo)
    },
    showPhoto(url) {
      this.$refs.photoModal.openModal(url)
    },
    getRealtyPhotoPromise(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
          let realtyPhoto = {}
          realtyPhoto['filename'] = file.name.trim()
          realtyPhoto['photo_data'] = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '')
          resolve(realtyPhoto)
        }
        reader.onerror = (error) => reject(error)
      })
    },
    resetPhotos() {
      this.photosToRemove = []
      this.selectedPhotos = []
    },
    async updatePhotos() {
      this.selectedPhotos = Array.from(this.$refs.photoInputUpload.files)
    },
    async deletePhotos() {
      if(this.photosToRemove.length >= 1){
        this.selectedPhotos = this.selectedPhotos.filter((it, index) => {
                return !this.photosToRemove.includes(index)
            }
        )
      }
      this.onRemoveSelection = false
      this.photosToRemove = []
    },
    selectAllPhotos() {
        if(this.selectedAllPhotos) {
            this.photosToRemove = this.selectedPhotos.map((it, index) => { return index })
        } else {
            this.photosToRemove = []
        }
    },
    handleRemoveSelection() {
      this.onRemoveSelection = !this.onRemoveSelection
      this.photosToRemove = []
    }
  }
}
</script>

<style scoped>
  .outlined {
    border: 3px solid #009DD9;
    cursor: pointer !important;
  }
  .pointer {
    cursor: pointer !important;
  }
</style>
